import { forwardRef, useEffect, useRef } from "react";

import styled from "styled-components/macro";

const useIntersectionObserver = (ref, callback, options) => {
  const observer = useRef(null);

  useEffect(() => {
    if (observer.current) {
      observer.current.disconnect();
    }

    observer.current = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        callback();
      }
    }, options);

    const currentRef = ref.current;
    if (currentRef) {
      observer.current.observe(currentRef);
    }

    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    };
  }, [ref, callback, options]);
};

const Bottom = styled.div`
  height: 1rem;
`;

export const LoadMore = forwardRef((props, ref) => <Bottom ref={ref} />);

export default useIntersectionObserver;
